import { DateTime, DateTimeFormatOptions } from 'luxon';
import React from 'react';
import * as styles from './styles.module.scss';

interface Props {
  message: { number: string; created: string; body: string };
  isThread?: boolean;
}

const SmsItem: React.FC<Props> = ({ message }) => {
  const yearAgo = DateTime.now().minus({ year: 1 });
  const date = DateTime.fromISO(message.created);
  const format: DateTimeFormatOptions =
    date > yearAgo ? { month: 'short', day: 'numeric' } : DateTime.DATE_SHORT;
  const dateString = date.toLocaleString(format);

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div>{message.number}</div>
        <div>{dateString}</div>
      </div>
      <div className={styles.body}>{message.body}</div>
    </div>
  );
};

export default SmsItem;
